(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-suivi-commande"]) return;
  try {
    
  (() => {
    const form = document.querySelector('[data-suivi-form]');
    const champ = document.querySelector('[data-suivi-input]');
    const zone = document.querySelector('[data-suivi-resultat]');
    if (!form || !champ || !zone) return;

    const afficher = (numero) => {
      zone.hidden = false;
      let essais = 0;
      const tenter = () => {
        if (window.YQV5 && typeof window.YQV5.trackSingle === 'function') {
          window.YQV5.trackSingle({ YQ_ContainerId: 'YQContainer', YQ_Height: 480, YQ_Fc: '0', YQ_Lang: 'fr', YQ_Num: numero });
          zone.scrollIntoView({ behavior: 'smooth', block: 'start' });
          return;
        }
        if (++essais < 40) { setTimeout(tenter, 150); return; }
        document.getElementById('YQContainer').textContent = 'Le service de suivi ne répond pas pour le moment. Écrivez-nous, nous vérifions pour vous.';
      };
      tenter();
    };

    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const n = (champ.value || '').trim().replace(/\s+/g, '');
      if (!n) { champ.focus(); return; }
      afficher(n);
      try { history.replaceState(null, '', `?num=${encodeURIComponent(n)}`); } catch (err) { /* ignoré */ }
    });

    const direct = new URLSearchParams(location.search).get('num');
    if (direct) { champ.value = direct; afficher(direct); }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["momo-chat"] && !Shopify.designMode) return;
  try {
    
  class MomoChat extends HTMLElement {
    connectedCallback() {
      this.fab = this.querySelector('[data-mchat-fab]');
      this.panel = this.querySelector('[data-mchat-panel]');
      this.thread = this.querySelector('[data-mchat-thread]');
      this.wa = this.querySelector('[data-mchat-wa]');
      this.base = this.wa ? 'https://wa.me/' + (this.dataset.wa || '') + '?text=' + encodeURIComponent(this.dataset.prefill || '') : '';
      if (this.wa) this.wa.setAttribute('href', this.base);
      this.fab.addEventListener('click', () => (this.panel.hidden ? this.open() : this.close()));
      this.querySelector('[data-mchat-close]').addEventListener('click', () => this.close(true));
      this.querySelectorAll('[data-mchat-q]').forEach((b) => b.addEventListener('click', () => this.ask(b)));
      this.onKey = (e) => { if (e.key === 'Escape' && !this.panel.hidden) this.close(true); };
      document.addEventListener('keydown', this.onKey);
      this.onDoc = (e) => { if (!this.panel.hidden && !this.contains(e.target)) this.close(); };
      document.addEventListener('click', this.onDoc);
      try { if (sessionStorage.getItem('mchat-seen')) this.classList.add('is-seen'); } catch (e) {}
    }
    disconnectedCallback() { document.removeEventListener('keydown', this.onKey); document.removeEventListener('click', this.onDoc); }
    open() {
      this.panel.hidden = false; this.setAttribute('data-open', '');
      requestAnimationFrame(() => this.panel.classList.add('is-open'));
      this.fab.setAttribute('aria-expanded', 'true');
      try { sessionStorage.setItem('mchat-seen', '1'); } catch (e) {}
      const first = this.querySelector('[data-mchat-q]') || this.querySelector('[data-mchat-close]');
      setTimeout(() => first && first.focus({ preventScroll: true }), 120);
      if (window.Momo) { const m = this.querySelector('.mchat__momo'); if (m) window.Momo.boing(m); }
    }
    close(focus) {
      this.panel.classList.remove('is-open'); this.removeAttribute('data-open');
      this.fab.setAttribute('aria-expanded', 'false');
      setTimeout(() => { this.panel.hidden = true; }, 350);
      if (focus) this.fab.focus({ preventScroll: true });
    }
    ask(btn) {
      const q = btn.textContent.trim(), a = btn.dataset.answer || '';
      const me = document.createElement('p'); me.className = 'mchat__msg mchat__msg--me'; me.textContent = q;
      this.thread.appendChild(me);
      btn.classList.add('is-used');
      setTimeout(() => {
        const mo = document.createElement('p'); mo.className = 'mchat__msg mchat__msg--momo'; mo.innerHTML = a;
        this.thread.appendChild(mo); this.thread.scrollTo({ top: this.thread.scrollHeight, behavior: 'smooth' });
        if (window.Momo) { const m = this.querySelector('.mchat__avatar .momo'); if (m && Math.random() < .5) window.Momo.yawn(m); }
      }, 420);
      this.thread.scrollTo({ top: this.thread.scrollHeight, behavior: 'smooth' });
      if (this.wa) this.wa.setAttribute('href', this.base + encodeURIComponent(' ' + q));
    }
  }
  if (!customElements.get('momo-chat')) customElements.define('momo-chat', MomoChat);

  } catch(e) { console.error(e); }
})();
})();
